export const DEFAULT_PACKING_CATEGORIES = [
  {
    category: "Documents",
    items: ["Passport", "Visa", "Driver's License", "Travel Insurance", "Booking Confirmations", "Emergency Contacts", "Vaccination Record"],
  },
  {
    category: "Clothing",
    items: ["T-shirts", "Pants / Jeans", "Underwear", "Socks", "Pajamas", "Sweater / Jacket", "Formal Outfit", "Swimwear", "Workout Clothes", "Rain Jacket"],
  },
  {
    category: "Shoes",
    items: ["Walking Shoes", "Sandals", "Dress Shoes", "Flip Flops"],
  },
  {
    category: "Toiletries",
    items: ["Toothbrush", "Toothpaste", "Shampoo", "Conditioner", "Soap / Body Wash", "Deodorant", "Razor", "Sunscreen", "Moisturizer", "Lip Balm", "Feminine Hygiene Products", "Makeup / Cosmetics"],
  },
  {
    category: "Health & Medicine",
    items: ["Prescription Medications", "Pain Reliever", "Antihistamine", "Bandages", "Antacids", "Motion Sickness Meds", "Hand Sanitizer", "Face Masks"],
  },
  {
    category: "Electronics",
    items: ["Phone + Charger", "Laptop + Charger", "Camera + Charger", "Power Bank", "Universal Adapter", "Earphones / Headphones", "E-reader"],
  },
  {
    category: "Carry-On Essentials",
    items: ["Neck Pillow", "Eye Mask", "Earplugs", "Snacks", "Water Bottle"],
  },
  {
    category: "Money & Finance",
    items: ["Credit Cards", "Cash (local currency)", "Travel Wallet", "ATM Card"],
  },
];

export function itemId(category, label) {
  return `${category}/${label}`;
}
